// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__I2Lwv","containerItemsCenter":"Skeleton_containerItemsCenter__2LsGt"};